export const ActionTypes = {
  LOADING: "SELECTED_OPTION1_LOADING",
  ERROR: "SELECTED_OPTION1_ERROR",
  SUCCESS: "SELECTED_OPTION1_SUCCESS",
};
